export default __webpack_public_path__ + "static/media/composer.1cc787c3.png";